import React from "react";
import { useSelector } from "react-redux";

import { getUser } from "@gamedev-web/gamedev-sdk-core";

import { GdkMiddlewareTextBox } from "./GdkMiddlewareTextBox";

export const NameBox = () => {
  const userInfo = useSelector(getUser);

  if (!userInfo?.firstName || !userInfo?.lastName) {
    return null;
  }

  const fullName = `${userInfo?.firstName || ""} ${userInfo?.lastName || ""}`;
  return <GdkMiddlewareTextBox value={fullName} disabled={true} />;
};
